import React from 'react'
import PageCustom from '@ublique/components/Template/PageCustom'
import UbliqueRow from '@ublique/components/Template/components/Row'
import UbliqueColumn from '@ublique/components/Template/components/Column'
import './index.scss'
import { TITLE_PAGE } from './constant'

const Similarity = () => {
  const renderIframe = () => {
    return (
      <UbliqueRow className='ublique-row-charts'>
        <UbliqueColumn>
          <iframe
            src='http://ovs-staging.ublique.ai/ublique/ovsnow/similarity-view/'
            title={TITLE_PAGE}
            className='iframe-sim'
          ></iframe>
        </UbliqueColumn>
      </UbliqueRow>
    )
  }
  return (
    <PageCustom
      title={TITLE_PAGE}
      className={'similarity_output'}
      children={renderIframe()}
    ></PageCustom>
  )
}

export default Similarity
